import Link from 'next/link';
import styles from '@features/cms/components/categories/CategoryTilesBlock/components/PromotionTile/PromotionTile.styles';
import { IPromotionTile } from '@features/cms/typescript';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import { IconList } from '@components/icons/components';
import { TIcon } from '@components/icons/typescript';
import theme from '@styles/theme';
type PropsType = {
  tile: IPromotionTile;
};
const PromotionTile = ({
  tile
}: PropsType) => {
  const {
    backgroundColor,
    iconName,
    iconColor,
    name,
    url
  } = tile;
  const iconType: TIcon | null = iconName && IconList.includes(iconName) ? iconName as TIcon : null;
  return <Link href={url ?? '/'}>
      <div sx={styles.container}>
        <div sx={styles.blockContainer(backgroundColor || theme.rawColors.accent700)}>
          {iconType && <Icon icon={iconType} color={iconColor || theme.rawColors.neutralWhite} addSx={styles.icon} size="100%" />}
        </div>
        <Heading h={4} headingType={4} mobile addSx={styles.heading}>
          {name}
        </Heading>
      </div>
    </Link>;
};
export default PromotionTile;